/**
 * Light/dark theme toggle (inc/smx-theme-mode.php).
 *
 * The light theme is the body class "smx-theme-light"; the choice is stored in
 * localStorage and applied before the first paint by an inline script.
 */
const STORAGE_KEY = "smx-theme";
const LIGHT_CLASS = "smx-theme-light";

function init() {
	const toggles = document.querySelectorAll("[data-smx-theme-toggle]");
	if (!toggles.length) return;

	toggles.forEach((toggle) => {
		toggle.addEventListener("click", () => {
			setLight(!document.body.classList.contains(LIGHT_CLASS));
		});
	});

	updateToggles();
}

function setLight(isLight) {
	document.body.classList.toggle(LIGHT_CLASS, isLight);

	try {
		localStorage.setItem(STORAGE_KEY, isLight ? "light" : "dark");
	} catch (e) {
		// Storage unavailable (private mode): the choice lasts for this page only.
	}

	updateToggles();
}

function updateToggles() {
	const isLight = document.body.classList.contains(LIGHT_CLASS);

	document.querySelectorAll("[data-smx-theme-toggle]").forEach((toggle) => {
		toggle.setAttribute("aria-pressed", isLight ? "true" : "false");
		toggle.setAttribute("aria-label", isLight ? toggle.dataset.labelDark : toggle.dataset.labelLight);
	});
}

export default { init };
